import gsap, { Power3, Power4 } from 'gsap';
import { GetBy } from '../_app/cuchillo/core/Element';
import EventDispatcher from '../_app/cuchillo/core/EventDispatcher';
import _Sidemenu from '../_app/cuchillo/layout/Sidemenu';
import { Ease } from '../_app/cuchillo/utils/Ease';
import { Sizes } from '../_app/cuchillo/core/Sizes';
import { isSmartphone } from '../_app/cuchillo/core/Basics';

export default class Sidemenu extends _Sidemenu {
  static _mode = "normal";
  static holder = GetBy.selector('#Sidemenu .holder')[0];
  static top = GetBy.selector('#Sidemenu .top')[0];
  static icon = GetBy.selector('#Sidemenu .cross')[0];
  static logo = GetBy.selector('#Sidemenu .logo svg')[0];
  static symbol = GetBy.selector('#Sidemenu .symbol svg')[0];
  static figure = GetBy.selector('#Sidemenu .sidemenu__video')[0];
  static video = GetBy.selector('#Sidemenu video')[0];
  static bg = GetBy.selector('#Sidemenu .bg')[0];
  static isButtonShow = false;

  static sizes = {
    open: { x: 0, y: 0, width: 0, height: 0, rotate: 135, bg_scale: 1 },
    close: { x: 0, y: 0, width: 0, height: 0, rotate: 0, offset: 0, bg_scale: 1 },
  };

  // Misma media que SCSS: max-width $smartphone (sin exigir touch)
  static get isNarrow() {
    return false;//window.matchMedia(`(max-width: ${Sizes.SMARTPHONE}px)`).matches;
  }

  static get mode() {
    return this._mode;
  }

  static set mode(__mode) {
    if (this._mode === __mode) return;
    this._mode = __mode;
  }

  static init() {
    this.directHide();
  }

  static loop() { }

  static show(__d = 0) {
    this.container.setAttribute('aria-expanded', 'true');
    this.state = Sidemenu.STATE_OPEN;

    if (this.video) this.video.play();

    this.show__effect();
    this.container.classList.add("--open");
  }

  // SHOW
  static show__effect(__d = 0) {

    this.sizes.close.rotate = this.sizes.open.rotate + 45;

    gsap.to(this.icon, {
      rotate: this.sizes.open.rotate,
      duration: 1,
      delay: __d,
      ease: Power4.easeOut
    });

    gsap.to(this.symbol, {
      rotate: -180,
      duration: 1,
      delay: __d,
      ease: Power4.easeOut
    });

    // Mobile: sólo crece en vertical (misma amplada cerrado/abierto).
    if (!this.isNarrow) {
      gsap.to(this.container, {
        width: this.sizes.open.width,
        duration: 1,
        delay: __d,
        ease: Ease.EASE_CUCHILLO_OUT
      });
    }

    gsap.to(this.container, {
      height: this.sizes.open.height,
      duration: .9,
      delay: __d,
      ease: Power4.easeInOut
    });

    gsap.to(this.figure, {
      opacity: 1,
      duration: .4,
      delay: __d + .5,
      ease: Power3.easeOut
    });
  }

  static afterShow() {
    EventDispatcher.dispatchEvent(Sidemenu.ON_SHOW_END);
  }

  static hide(__d = 0) {
    this.state = Sidemenu.STATE_CLOSE;
    this.hide__effect();
    this.container.classList.remove("--open");
  }

  static hide__effect() {
    this.sizes.open.rotate = this.sizes.close.rotate + 135;

    gsap.to(this.icon, {
      rotate: this.sizes.close.rotate,
      duration: .8,
      ease: Power4.easeOut
    });

    gsap.to(this.symbol, {
      rotate: 0,
      duration: .8,
      ease: Power4.easeOut
    });

    const hideProps = {
      height: this.sizes.close.height,
      duration: 0.6,
      ease: Power4.easeOut
    };
    if (!this.isNarrow) hideProps.width = this.sizes.close.width;

    gsap.to(this.container, hideProps);

    gsap.to(this.figure, {
      opacity: 0,
      duration: .4,
      ease: Power3.easeOut
    });

    this.afterHide();
  }

  static directHide() {
    this._state = Sidemenu.STATE_CLOSE;
    this.afterHide();
  }

  static afterHide() {
    if (this.video) this.video.pause();
    this.container.setAttribute('aria-expanded', 'false');
    EventDispatcher.dispatchEvent(Sidemenu.ON_HIDE_END);
  }

  static resize() {
    this.container.removeAttribute("style");

    this.sizes.open.height = this.holder.offsetHeight;
    this.sizes.close.height = this.top.offsetHeight;

    if (this.isNarrow) {
      // Amplada fija (CSS); sólo crece en vertical.
      const w = this.holder.offsetWidth;
      this.sizes.open.width = w;
      this.sizes.close.width = w;
    } else {
      this.sizes.open.width = this.holder.offsetWidth;
      if(isSmartphone) {
        this.sizes.close.width = Math.max(this.sizes.open.width * .70, 249);
      } else {
        this.sizes.close.width = this.sizes.open.width * .34;
      }
    }

    if (this.isOpen) {
      gsap.set(this.container, { height: this.sizes.open.height, width: this.sizes.open.width });
    } else {
      gsap.set(this.container, { height: this.sizes.close.height, width: this.sizes.close.width });
    }
  }
}
